export default __webpack_public_path__ + "static/tooltip-interactive-1-do-light-0fc0c1db66b4ba98daf358a442ce89a2.png";